const APP_CONFIG = {
  FRONTEND_VERSION: 50,
  CLIENT_PLATFORM: "web",
};

export default APP_CONFIG;
